// extracted by mini-css-extract-plugin
export default {"wrapper":"_Z-z","boldPrefix":"a0-z","link":"b0-z","message":"c0-z","image":"d0-z"};